import { useTranslation } from "react-i18next";

export default function WhyUs() {
  const { t } = useTranslation();
  const features = t("home.whyUs.features", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
  }>;

  const icons = [
    "ri-list-check-2",
    "ri-lightbulb-line",
    "ri-refresh-line",
    "ri-eye-line",
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            {t("home.whyUs.title")}
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t("home.whyUs.content")}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => (
            <div key={feature.title} className="text-center p-6">
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${icons[i]} text-emerald-700 text-2xl`} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}